import React, { Component } from 'react';
import { toast, cssTransition } from 'react-toastify';

//error boundary class - prevents app from crashing completely.
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true });
    this.logErrorToMyService(error, info);
  }

  logErrorToMyService(error, info) {
    //TODO send error to service
  }

  showErrorNotification() {
    const toastAnimation = cssTransition({
      enter: 'fade-in-top',
      exit: 'fade-out-top',
      duration: [500, 800]
    });

    !toast.isActive("error-bndry") &&
      toast(
          <h1 className="error-boundary">{this.props.msg ? this.props.msg : 
            "Something went wrong."}<br /><span className="eb-link" onClick={() => {
              typeof window !== "undefined" && window.location.reload(true);
            }}
          >Click here to reload.</span></h1>,
        {
          position: "top-center",
          autoClose: false,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
          toastId: "error-bndry",
          transition: toastAnimation
        });
  }

  render() {
    // if (this.state.hasError) {
    //   return <h1 className="error-boundary">{this.props.msg ? this.props.msg : 
    //     "Something went wrong."} <span className="eb-link" onClick={() => {
    //       typeof window !== "undefined" && window.location.reload(true);
    //     }}
    //   >Click here to reload.</span></h1>
    // }
    return <>
      {this.state.hasError && this.showErrorNotification()}
      {this.props.children}
    </>
  }
}

export default ErrorBoundary;